import { useEffect, useState } from "react";
import { t as getFixedT } from "@/i18n";
import type { SupportedLanguage } from "@/lib/site";
import "./BackToTop.css";

/** Floating "scroll to top" button — hidden at the top of the page, fades in once the user has
 * scrolled down, and smooth-scrolls back to the top on click (instant under reduced motion, which
 * the browser honours automatically for `scrollTo({ behavior: 'smooth' })` via `scroll-behavior`). */
export function BackToTop({ lang }: { lang: SupportedLanguage }) {
  const t = getFixedT(lang);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 600);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`fa-back-to-top${visible ? " fa-back-to-top--visible" : ""}`}
      aria-label={t("nav.backToTop")}
      title={t("nav.backToTop")}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <svg viewBox="0 0 20 20" width="22" height="22" aria-hidden="true" focusable="false">
        <path
          d="M10 15.5V5M5 9.5 10 4.5l5 5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
